/**
 *
 * Elastic For SIEM Integration
 *
 */

import React, { FC } from 'react';

import { ClientsApiEditClientRequest } from '@ariksa/notification/api';
import { useDispatch, useSelector } from 'react-redux';

import { useIntegrations } from 'containers/Setup/Integrations/hooks/useIntegrations';
import { selectIntegrations } from 'containers/Setup/Integrations/selectors';

import { actions } from '../../../../slice';

import { ElasticForSIEMForm } from './ElasticForSIEMForm';

export const EditElasticForSIEM: FC = () => {
  const dispatch = useDispatch();
  const { onCancel } = useIntegrations();
  const { activeClient } = useSelector(selectIntegrations);

  const onSubmit = data => {
    const payload: ClientsApiEditClientRequest = {
      uuid: activeClient.data?.uuid,
      editClientConfig: {
        //name: data.name,
        //status: true,
        description: data?.description,
        /*elastic_search: {
          ...(data?.api_Key === DUMMY_API_KEY
            ? {}
            : { api_key: data?.api_key }),
        },*/
      },
    };
    dispatch(
      actions.updateClientById({
        q: payload,
        onSuccess: () => onCancel(),
      }),
    );
  };

  return <ElasticForSIEMForm onSubmit={onSubmit} actionType="Update" />;
};
